module.exports = __webpack_public_path__ + "static/NCAGE_CODE-6ed8c891165bcda60db7a470d0565e6a.pdf";